import { yup } from '@framework/validation';
import { values } from 'lodash';
import { ExpressionType } from '../../IExpression';
import { createExpressionType } from '../../IExpressionType';
import { IAsyncExpression } from './IAsyncExpression';

export const AsyncExpressionType = createExpressionType<IAsyncExpression>({
  type: ExpressionType.Async,
  schema: yup.object({
    type: yup.string().exact(ExpressionType.Async).required(),
    serviceId: yup.string().label('Servizio').required(),
    inputs: yup.object().label('Parametri').required(),
    output: yup.string().label('Campo').required(),
  }),
  evaluate(expression, scope) {
    // TODO Supportare valutazione asincrona
    throw new Error('[AsyncExpression] Not implemented');
  },
  getReferences(expression, collect) {
    return values(expression.inputs).flatMap(collect);
  },
  toString(expression) {
    return `[AsyncService]`;
  },
});
